<form
  class="mx-[12px]"
  [formGroup]="forgotPasswordForm"
  (ngSubmit)="submitForm()"
>
  <p class="mt-[32px] font-inter font-bold text-base xlplus:text-lg">
    Forgot Password
  </p>
  <p
    class="mt-[16px] font-lato font-normal text-sm xlplus:text-base text-taxpod-gray-light"
  >
    Please enter your email address to reset password.
  </p>
  <div class="flex flex-col gap-2 mt-[8px]">
    <input
      type="email"
      class="!text-sm xlplus:!text-base placeholder-color"
      [ngClass]="
        inputtedEmail?.touched && inputtedEmail?.hasError('invalidEmailSyntax')
          ? '!border-taxpod-red'
          : '!border'
      "
      pInputText
      formControlName="email"
      name="email"
      [attr.autocomplete]="autocompleteEnabled() ? 'username' : 'off'"
      placeholder="Enter your email"
    />
  </div>
  <!--
    Deliberately NO "Email is required" message: an empty email is communicated
    by the disabled "Reset Password" button alone (P.O. scope change). Only a
    non-empty, malformed address earns inline copy - and the red border above is
    keyed on the same condition so border and text always appear together.
  -->
  @if (inputtedEmail?.touched && inputtedEmail?.hasError('invalidEmailSyntax')) {
  <div class="mt-[8px]">
    <p class="font-lato text-xs xlplus:text-sm font-normal text-[#e73a3a]">
      Invalid email format
    </p>
  </div>
  }

  <div class="mt-[24px]">
    <p-button
      type="submit"
      [loading]="isSubmitting"
      [disabled]="isButtonDisabled()"
      styleClass="!w-full !bg-taxpod-blue !border-taxpod-blue disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
      ><p class="font-lato font-bold text-sm xlplus:text-base">
        Reset Password
      </p></p-button
    >
  </div>
</form>
<p
  class="flex justify-center items-center gap-2 mt-[16px] mx-[12px] mb-[12px] font-lato font-bold text-center text-sm xlplus:text-base cursor-pointer text-taxpod-blue"
  routerLink="/auth/login"
>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.04754 13.0623L7.35387 13.774C7.06015 14.0753 6.5852 14.0753 6.29461 13.774L0.220288 7.545C-0.0734293 7.24365 -0.0734293 6.75636 0.220288 6.45821L6.29461 0.226013C6.58833 -0.0753378 7.06327 -0.0753378 7.35387 0.226013L8.04754 0.937715C8.34438 1.24227 8.33813 1.73918 8.03504 2.03733L4.26984 5.71766H13.2501C13.6657 5.71766 14 6.06068 14 6.48706V7.51294C14 7.93932 13.6657 8.28235 13.2501 8.28235H4.26984L8.03504 11.9627C8.34126 12.2608 8.34751 12.7577 8.04754 13.0623Z"
      fill="#00B0ED"
    />
  </svg>
  Back to Login
</p>
